import type { CalculatorPackage } from '@/api/calculatorPackages';

/** Clone for "duplicate package" flow: same calculator data, new name with ` - copy` suffix. */
export function buildDuplicateInitialPackage(pkg: CalculatorPackage): CalculatorPackage {
  const base = pkg.name?.trim() || 'Package';
  const { _id, createdAt, updatedAt, updatedBy, createdBy, ...rest } = pkg;
  void _id;
  void createdAt;
  void updatedAt;
  void updatedBy;
  void createdBy;
  return {
    ...rest,
    _id: '',
    name: `${base} - copy`
  };
}
